import { render } from "./PrevNext.vue?vue&type=template&id=783d70cc"
import script from "./PrevNext.vue?vue&type=script&lang=js"
export * from "./PrevNext.vue?vue&type=script&lang=js"

import "./PrevNext.vue?vue&type=style&index=0&id=783d70cc&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__